import { StorageEvent } from './events';
var StorageEvents = /** @class */ (function () {
    function StorageEvents(eventBus) {
        var _this = this;
        this.onClosed = function (handler) {
            _this.eventBus.on(StorageEvent.Closed, handler);
        };
        this.eventBus = eventBus;
    }
    StorageEvents.prototype.onReady = function (handler) {
        this.eventBus.on(StorageEvent.Ready, handler);
    };
    StorageEvents.prototype.onFetal = function (handler) {
        this.eventBus.on(StorageEvent.Fetal, handler);
    };
    StorageEvents.prototype.onError = function (handler) {
        this.eventBus.on(StorageEvent.Error, handler);
    };
    StorageEvents.prototype.onRegisterModel = function (handler) {
        this.eventBus.on(StorageEvent.RegisterModel, handler);
    };
    StorageEvents.prototype.onRegisterPlugin = function (handler) {
        this.eventBus.on(StorageEvent.RegisterPlugin, handler);
    };
    StorageEvents.prototype.onBootstrapStart = function (handler) {
        this.eventBus.on(StorageEvent.BootstrapStart, handler);
    };
    StorageEvents.prototype.onBootstrapEnd = function (handler) {
        this.eventBus.on(StorageEvent.BootstrapEnd, handler);
    };
    StorageEvents.prototype.onSchemaMigrationStart = function (handler) {
        this.eventBus.on(StorageEvent.SchemaMigrationStart, handler);
    };
    StorageEvents.prototype.onSchemaMigrationEnd = function (handler) {
        this.eventBus.on(StorageEvent.SchemaMigrationEnd, handler);
    };
    /**
     * set versionchange event listener
     * the versionchange event is fired when a database structure change, such as database upgrade or delete
     * @param handler a event handler
     */
    StorageEvents.prototype.onVersionChange = function (handler) {
        this.eventBus.on(StorageEvent.VersionChange, handler);
    };
    StorageEvents.prototype.emitError = function (error) {
        this.eventBus.emit(StorageEvent.Error, error);
    };
    return StorageEvents;
}());
export { StorageEvents };
//# sourceMappingURL=storage-events.js.map